import Utils from '@/core/utils'
const state = {
  propertyDefinition: [], // 某个品类下所有的查价条件为“是”的属性定义
  flatAreas: [],
  rootCode: '1',
}
const getters = {
  areas: (state) => state.flatAreas,
  areaTree: (state) => {
    return Utils.listToTree(state.flatAreas || [], 'code', state.rootCode)
  },
  propertyDefinition: (state) => state.propertyDefinition
}
const mutations = {
  setPropertyDefinition(state, definition) {
    state.propertyDefinition = definition
  },
  setFlatAreas(state, flatAreas) {
    const rootNode = flatAreas.find((a) => !a.parentCode)
    state.rootCode = rootNode ? rootNode.code : '1'
    flatAreas.forEach((fa) => {
      fa.id = `${fa.code}+${fa.name}`
      fa.parentId = `${fa.parentCode}+${fa.parentName}`
    })
    state.flatAreas = flatAreas
  }
}
const actions = {
  async loadPropertyDefinition({ state, commit }, classificationCode) {
    try {
      const params = {
        configItemValues: [
          {
            code: 'isPriceCondition',
            value: 'true'
          }
        ]
      }
      const propertyDefinition = await this.$api.classification.getClassificationProperties(classificationCode, params)
      commit('setPropertyDefinition', propertyDefinition || [])
    } catch (error) {
      commit('setPropertyDefinition', [])
    }
  },
  async loadAreas({ state, commit }) {
    try {
      if (!state.flatAreas.length) {
        const res = await this.$api.areas.list()
        commit('setFlatAreas', res || [])
      }
    } catch (error) {
      commit('setFlatAreas', [])
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
